import { Dropdown as AntdDropdown, Space } from "antd";

const Dropdown = (props) => {
  const {
    items,
    label = "Click me",
    icon = null,
    trigger = ["click"],
    onSelect, // new preferred prop
    onClick, // backwards compatible prop
    ...rest
  } = props;

  // Decide which handler to use
  const handler = onSelect || onClick;

  return (
    <AntdDropdown
      menu={{
        items,
        onClick: handler,
      }}
      trigger={trigger}
      {...rest}
    >
      <a
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation(); // keep dropdown stable
        }}
      >
        <Space>
          {label}
          {icon}
        </Space>
      </a>
    </AntdDropdown>
  );
};

export default Dropdown;
